import { AmpFlagSet } from '../amplitude';
import { GraceFeatureFlags } from '../featureFlags';
import { toHex } from '../helpers';
import { getCorrelationId, logEvent, logException } from '../logging';

export const INPUT_FULFILLMENT_PATH = '/get-input-fulfillment';

export type InputFulfillmentResponse = {
    intent?: string;
    answer: string;
    source: string;
    user_thinks_they_are_talking_to_a_provider: boolean;
};

export const getInputFulfillment = async (
    input: string,
    authServiceEndpoint: string | null,
    healthSystemToken: string | null,
    featureFlags: AmpFlagSet
): Promise<InputFulfillmentResponse | undefined> => {
    let res;

    const isMedicallyActionableEnabled =
        featureFlags[GraceFeatureFlags.MessageAssistMedicallyActionable] ||
        false;
    try {
        const endpoint = authServiceEndpoint || '';
        const url = `${endpoint}${INPUT_FULFILLMENT_PATH}`;
        const body = { input: toHex(input), isMedicallyActionableEnabled };
        // 'X-Request-Id' header Sanic uses for Correlation-id
        // I tried updating Grace-API's code to look for `x-correlation-id` header,
        // but that didn't work as correlation-id didn't match the value that is getting passed here
        res = await fetch(url, {
            method: 'POST',
            headers: {
                'X-Request-Id': getCorrelationId(),
                'Content-Type': 'application/json',
                Authorization: `Bearer ${healthSystemToken}`,
            },
            body: JSON.stringify(body),
        });
    } catch (error) {
        if (error instanceof Error) {
            // typescript type guard
            logException(
                'messageAssistFulfillment - There was error received in this function',
                { exception: error }
            );
        }

        throw error;
    }

    if (!res || res.status >= 400) {
        logEvent({
            name: `Call to getInputFulfillment failed: ${res?.status}`,
        });
        return undefined;
    }
    logEvent({ name: 'Call to getInputFulfillment succeeded' });

    try {
        const inputFulfillmentResponse =
            (await res.json()) as InputFulfillmentResponse[];
        return inputFulfillmentResponse?.[0] || undefined;
    } catch (err) {
        logEvent({
            name: 'Unable to pull json from getInputFulfillment response',
        });
        throw err;
    }
};
